module.exports = __webpack_public_path__ + "img/mouth_male_thin_mask.a05b5562.png";